import { classNames } from "../../utils/styling-utils"
import { DayInfo, getDayNumber } from "./utils"

export interface IEnkCalendarDayProps {
  day: DayInfo
}

export function EnkCalendarDay(props: IEnkCalendarDayProps) {
  const { day } = props
  return (
    <span
      className={classNames(
        "mt-3 flex h-8 w-8 items-center justify-center rounded-full",
        day.isSelected ? "bg-primary text-white" : "",
        day.isToday && !day.isSelected ? "bg-gray-900 text-white" : "",
        day.isToday || day.isSelected ? "text-base font-semibold" : ""
      )}
    >
      {getDayNumber(day)}
    </span>
  )
}
